import { useCurrentUser } from 'lib/contexts/ApplicationState';
import { useUpgradeModal, usePaidSubscriptionModal } from 'components/UpgradeModal';
import { ReactElement } from 'react';
import { userIsAdmin, userIsPro, userIsTeamMember } from 'lib/helpers';
import { UserState } from 'lib/types/users';
import { MobileTooltip } from 'components/MobileTooltip';
import { ProBadge } from 'components/ProBadge';

// TODO: update this component

interface TooltipProps {
  children: ReactElement;
  title: string;
}

const userGetsTooltip = (user: UserState) => {
  if (userIsPro(user) || userIsAdmin(user)) {
    return true;
  }
  return false;
};

const TooltipForPro = ({ children, title }: TooltipProps) => {
  const currentUser = useCurrentUser();
  if (userGetsTooltip(currentUser)) {
    return (
      <MobileTooltip
        title={title}
        placement="top-end"
      >
        {children}
      </MobileTooltip>
    );
  }
  return <div>{children}</div>;
};

interface Props {
  /** The text displayed in the tooltip for Pros/Teams */
  title: string;
  /** The text displayed in the upsell dialog for non Pros/Teams */
  upgradeTitle: string;
  styling?: string;
  teamsFeature?: boolean;
}

/** Non pros/teams gets one tooltip with upsell dialog, Pros/teams get another tooltip */
export const FeaturedTag = ({
  title, styling, upgradeTitle, teamsFeature = false,
}: Props) => {
  const { showUpgradeModal } = useUpgradeModal();
  const { showPaidSubscriptionModal } = usePaidSubscriptionModal();
  const currentUser = useCurrentUser();

  const openDialog = () => {
    if (teamsFeature && userIsTeamMember(currentUser)) {
      showPaidSubscriptionModal(upgradeTitle);
      return;
    }
    showUpgradeModal(upgradeTitle);
  };

  return (
    <div>
      <TooltipForPro title={title}>
        <button
          type="button"
          onClick={() => (!userGetsTooltip(currentUser) ? openDialog() : null)}
          className={styling || 'absolute right-0'}
        >
          <ProBadge />
        </button>
      </TooltipForPro>
    </div>
  );
};
